import { memo, type HTMLAttributes } from 'react';

import { cn } from '../../lib/cn';

export interface CharacterCounterProps extends HTMLAttributes<HTMLDivElement> {
  max: number;
  current: number;

  /**
   * The threshold at which the character counter is displayed.
   * If the current number of characters is less than the display threshold,
   * the character counter is not displayed.
   *
   * When not provided, character counter is always displayed.
   */
  displayThreshold?: number;
}

export const CharacterCounter = memo(
  ({
    max,
    current,
    className,
    displayThreshold = max * 0.95,
    ...restProps
  }: CharacterCounterProps) => {
    if (displayThreshold && current < displayThreshold) {
      return null;
    }

    return (
      <div
        className={cn(
          'text-[11px] text-right',
          current >= max
            ? 'text-chat-destructive'
            : 'text-chat-muted-foreground',
          className,
        )}
        {...restProps}
      >
        {current}
        <span className='text-[9px]'> / {max}</span>
      </div>
    );
  },
);
